module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<div class="'+(props.styles.title)+' '+(props.themeStyles.titleText)+'" data-playable-hook="video-title"></div>';return out;
} 
  };